import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Link } from 'react-router-dom'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'

import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import { Button, message } from 'antd'


class Message extends Component {

    static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        name: null
    }

    componentWillMount() {
        const { location, history } = this.props
        let name = null

        if (location.state && location.state.name) {
            name = location.state.name
        }
        const param = new URLSearchParams(location.search).get("name")
        if (param) {
            name = param
        }

        if (name) {
            this.setState({ name })
        } else {
            history.push('/login')
        }
    }

    resendValidationMail = () => {
        const { intl, location } = this.props
        callApi({
            endpoint: 'register/' + location.state.userId+ '/send',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'message.validationEmailSent'}))
        }).catch((data) => {
            if (data.status === 429) {
                message.warn(intl.formatMessage({id: 'misc.tooManyRequests'}))
            } else {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
            }
        })
    }

    render() {
        const { name, values } = this.state

        return (
            <div style={{ marginTop: "75px", textAlign: "center" }}>
                <span style={{ fontSize: "40px" }}><FormattedMessage id={"message." + name + "Title"} values={values} /></span>
                <br /><br /><br />
                <FormattedHTMLMessage id={"message." + name + "Description"} values={values} />
                <br /><br />
                {
                    (name === 'emailNotValidated') ? <span><Button onClick={this.resendValidationMail}><FaIcon icon="paper-plane"/> Renvoyer un nouveau mail</Button><br /><br /></span> : null
                }
                <Link to="/login"><FaIcon icon="arrow-left" fixedWidth /> <FormattedMessage id="message.backToLogin" /></Link>
            </div>
        )
    }

}

export default withRouter(injectIntl(Message))


// WEBPACK FOOTER //
// ./src/containers/Message.js